export default "__VITE_ASSET__ecc24294__"